import React from 'react'
import { injectIntl } from 'react-intl'

import * as S from './RegisterWizard.styled'

const Step4NextSteps = ({ intl }) => {
  return (
    <S.Step4>
      <h2 className="header-page-create-account" dangerouslySetInnerHTML={{ __html: intl.messages.register.step4.title }} />

      <div className="next-steps">
        {Object.values(intl.messages.register.step4.text1).map((d, k) => (
          <p key={k} dangerouslySetInnerHTML={{ __html: d }} />
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <S.Pipeline>
          <div className="pipeline">
            {Object.values(intl.messages.register.step4.pipeline).map((step, key) => (
              <div className={`pipeline__step ${key === 0 && 'pipeline__step--done'} ${key === 1 && 'pipeline__step--current'}`}>
                <div className="pipeline__line">
                  <div className="pipeline__line-indicator"><div className="circle" /></div>
                </div>
                <div className="step">
                  <div className="step__number">{step.step}</div>
                  <div className="step__name">{step.title}</div>
                  <div className={`step__tag ${key === 0 && 'step__tag--done'} ${key === 1 && 'step__tag--current'}`}>{step.label}</div>
                  <div className="step__description">
                    {Object.values(step.details).map((d, k) => (
                      <p key={k} dangerouslySetInnerHTML={{ __html: d }} />
                    ))}
                  </div>
                  {step.hasOwnProperty('delay') && (
                    <div className="step__estimate">
                      <div className="step__estimate-title">{intl.messages.register.step4.time}</div>
                      <div className="step__estimate-value">{step.delay}</div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          <S.ObsTiming>
            <h3>{intl.messages.register.step4.obs.title}</h3>
            <div>
              {Object.values(intl.messages.register.step4.obs.details).map((d, k) => (
                <p key={k} dangerouslySetInnerHTML={{ __html: d }} />
              ))}
            </div>
          </S.ObsTiming>
        </S.Pipeline>
      </div>

      
    </S.Step4>
  )
}

export default injectIntl(Step4NextSteps)